import { ApolloCache, Reference } from "@apollo/client"
import { CUSTOMER_FRAGMENT } from "../fragment/customer"

export const updateCacheCustomer = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      users(existing = []) {
        const newCustomerRef = cache.writeFragment({
          data: entryData,
          fragment: CUSTOMER_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newCustomerRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newCustomerRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newCustomerRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newCustomerRef
            }
            return items
        }
      },
      aggregateUser(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
